import styled, { css } from '@app/styled';
import { outline } from '@app/styles';
import { color } from '@app/theme';
import { modifier } from '@lokalise/styled';

import CheckboxCheckedFilled from './icons/CheckboxCheckedFilled';
import CheckboxEmpty from './icons/CheckboxEmpty';

export const Container = styled.div`
    position: relative;
    display: grid;
    grid-auto-flow: row;
    gap: 4px;
    width: 100%;

    &:hover input[type='checkbox']:checked + svg {
        stroke: ${color('background.action.primary.default')};
        color: ${color('background.action.primary.default')};
    }
`;

export const Label = styled.label`
    cursor: pointer;
    display: grid;
    grid-template-columns: min-content;
    grid-auto-flow: column;
    gap: 4px;
    /* Required because of global styles applied by bootstrap */
    margin: 0;
`;

export interface CheckboxIconProps {
    checked?: boolean;
}

export const iconSize = '20px';

export const CheckboxDefault = styled.svg.attrs<CheckboxIconProps>(({ checked }) => ({
    as: checked ? CheckboxCheckedFilled : CheckboxEmpty,
}))<CheckboxIconProps>`
    stroke: ${color('border.input.hover')};
    font-size: ${iconSize};
    transition: stroke 0.2s;

    ${Container}:hover &,
    [data-dev-state='hover'] & {
        stroke: ${color('border.input.hover')};
    }

    ${modifier(
        'checked',
        css`
            color: ${color('background.action.primary.default')};
            stroke: ${color('background.action.primary.default')};

            path {
                stroke: none;
            }
        `,
    )};
`;

export const Input = styled.input`
    position: absolute;
    opacity: 0;
    outline: none;
    cursor: pointer;

    /*
    * Focus outline is only visible when user is using keyboard. This behavior matches native radio behavior.
    */
    &:focus-visible + svg {
        ${outline}
    }
`;

export const Text = styled.span`
    color: ${color('text.light.default')};
    font-size: 14px;
    font-weight: normal;
    display: flex;
    align-items: center;
    gap: 4px;
`;

export const MultiCheckboxContainer = styled.div`
    width: 100%;
`;

export const MultiCheckbox = styled.div`
    display: grid;
    gap: 12px;
`;

export const MultiCheckboxErrorContainer = styled.div`
    padding-top: 12px;
    display: grid;
    gap: 4px;
`;
